export const AGENT_FABRIC_GA_ENABLED = 'agent-fabric-ga-enabled';
export const AGENT_SCANNERS_ENABLED = 'agent-scanners-enabled';
export const ANG_SEARCH_ENABLED_FLAG = 'ang-search-enabled';
export const APPCUES_STANDALONE_ENABLED = 'appcues-standalone-enabled';
export const APIC_PRE_RELEASE_ENABLED = 'apic-pre-release-enabled';
export const GLOBAL_NAVBAR_SUPPORT_ENABLED = 'global-navbar-support-enabled';
export const ONE_TRUST_ENABLED = 'one-trust-enabled';
export const REMOVE_MULESOFT_ORG_REVIEWS_ENABLED =
  'remove-mulesoft-org-reviews-enabled';
export const ONE_TRUST_PRODUCTIVE_SCRIPT = 'one-trust-productive-script';
export const PUBLISH_FORM_V2_ENABLED = 'publish-form-v2-enabled';
export const APID_DEPRECATION_ENABLED = 'apid-deprecation-enabled';
export const PORTAL_RE_ARCHITECTURE_ENABLED = 'portal-re-architecture-enabled';
export const PUBLIC_PORTAL_PIRA_ENABLED = 'public-portal-pira-enabled';
export const LOGGED_OUT_PIRA_ENABLED = 'logged-out-pira-enabled';
export const ASSETS_DEFINITIONS_VERSION = 'assets-definitions-version';
export const FEDERATED_ASSETS_DEFINITIONS_ENABLED =
  'federated-assets-definitions-enabled';
export const GLOBAL_ANG_SEARCH_ENABLED = 'global-ang-search-enabled';
export const REUSE_METRICS_ENABLED = 'reuse-metrics-enabled';
export const ANG_DEFAULT_ENABLED = 'ang-default-enabled';
export const PORTAL_SEARCH_ENABLED = 'portal-search-enabled';
export const SEARCH_EXPERIMENT = 'search-experiment';
export const LUME_THEME_ENABLED = 'lume-theme-enabled';
export const ORG_LEVEL_SETTINGS_ENABLED = 'org-level-settings-enabled';
export const API_NOTEBOOK_ENABLED = 'api-notebook-enabled';
